import React, { useState, useEffect } from "react";
import { Validation } from '../../utils/validation';
import ShareMessageModal from './ShareMessageModal';
import './Modal.css';
import NetPriceReportServices from '../../services/NetPriceReportServices';

const ShareModal = ({ isShow, customer, onClose }) => {
	const [errors, setErrors] = useState({});
	const [fields, setFields] = useState({});
	const [successMessage, setSuccessMessage] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [showShareMessageModal, setShowShareMessageModal] = useState(false);

	const netPriceReportServices = new NetPriceReportServices();

	useEffect(() => {
		if (isShow) {
			setFields({});
			setErrors({});
		}
	}, [isShow]);

	const handleChange = (e) => {
		const { name, value } = e.target;
        const newFormData = {
            ...fields,
            [name]: value,
        };
        setFields(newFormData);
        setErrors({});
    };

    const handleSubmit = () => {
    	let errors = Validation(fields,['email']);
    	if (Object.keys(errors).length > 0) {
    		setErrors(errors);
    		return;
    	}
    	submitShare()
    };

    const submitShare = async() => {
    	const newFields = {
    		...fields,
    		company_name:customer.label,
    		format:'both'
    	}
    	onClose();
    	setShowShareMessageModal(1);
    	netPriceReportServices.shareNetprice(newFields).then(response => {
    		if(response.response === 'success') {
    			setSuccessMessage(response.message);
    		} else {
    			setErrorMessage(response.message);
    		}
    		setTimeout(() => {
    			setShowShareMessageModal(0);
    			setSuccessMessage('');
    			setErrorMessage('');
    		},2000);
    	});
    }

    return (
    	<React.Fragment>
	      {isShow && (
	        <div className="motor-modal-overlay">
	          <div className="motor-modal-content">
	            <form className="motor-error-report-form d-flex flex-column gap-3" onSubmit={handleSubmit}>
	              <div className="form-group">
	                <label htmlFor="email">Email</label>
	                <input
	                  type="text"
	                  className="form-control"
	                  id="email"
	                  name="email"
	                  value={fields.email}
	                  onChange={handleChange}
	                />
	                {errors.email && (
	                  <div className="text-danger">{errors.email}</div>
	                )}
	              </div>
	              <div className="d-flex w-100 justify-content-evenly gap-4">
	                <button
	                  type="button"
	                  className="btn btn-secondary w-50 m-0 rounded"
	                  onClick={onClose} // parent will toggle modal
	                >
	                  Close
	                </button>
	                <button
	                  type="submit"
	                  className="submit-button w-50 m-0 rounded submit-error-report"
	                >
	                  Share
	                </button>
	              </div>
	            </form>
	          </div>
	        </div>
	      )}
	      <ShareMessageModal isShow={showShareMessageModal} onClose={() => setShowShareMessageModal(false)} successMessage={successMessage} errorMessage={errorMessage}/>
	    </React.Fragment>
	);
};

export default ShareModal;